<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Claim Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs6 sm6>
                    <v-text-field v-model="filtersClm.rcvyDocNo" :label="labels.rcvyDocNo" data-vv-name="rcvyDocNo"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6>
                    <v-text-field v-model="filtersClm.clmNo" :label="labels.clmNo" data-vv-name="clmNo"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-data-table
                :headers="headers"
                :items="displayItems"
                :loading="loading"
                :custom-filter="customSearch"
                :no-data-text="noDataText"
                item-key="key"
                v-bind:search="search"
                v-model="selected"
                :items-per-page="5"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td>{{ row.item.rcvyDocNo }}</td>
                    <td>{{ row.item.clmNo }}</td>
                    <td>{{ row.item.riType }}</td>
                    <td>{{ row.item.riCo }}</td>
                    <td>{{ row.item.acctNoSfx }}</td>
                    <td style="text-align: center">
                      <v-btn text icon color="primary" type="submit" @click.prevent="doSelect(row.item, 'rcvyDocNo')">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  props: {
    inoutwards: String,
    fromDate: String,
    toDate: String
  },
  data() {
    return {
      headers: [
        { text: 'Recovery Doc No', value: 'rcvyDocNo' },
        { text: 'Claim No.', value: 'clmNo' },
        { text: 'RI Type', value: 'riType' },
        { text: 'RI Co.', value: 'riCo' },
        { text: 'Suffix', value: 'acctNoSfx' },
        { text: 'Action', value: '' }
      ],
      selected: [],
      parameter: [],
      items: [],
      displayItems: [],
      paramItems: [],
      checkedItems: [],
      checkedItemsAll: [],
      labels: {
        rcvyDocNo: 'Rcvy Doc No.',
        clmNo: 'Claim No.'
      },
      filtersClm: {
        rcvyDocNo: undefined,
        clmNo: undefined
      }
    }
  },
  created() {
    this.doInit()
  },
  watch: {
    'filtersClm.rcvyDocNo': function (value) {
      if (value) {
        this.displayItems = this.items.filter((item) => item.rcvyDocNo.toLowerCase().includes(value.toLowerCase()))
      } else {
        this.displayItems = this.items
      }
    },
    'filtersClm.clmNo': function (value) {
      if (value) {
        this.displayItems = this.items.filter((item) => item.clmNo.toLowerCase().includes(value.toLowerCase()))
      } else {
        this.displayItems = this.items
      }
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.reports.claimReports.menu.clmRiRcvyRClmList
      if (apiURI) {
        this.loading = true
        const expand = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.selectedItems = []
            const data = result.data.dataList
            if (data) {
              data.map((item) => {
                const convertList = {
                  key: item.label,
                  clmNo: item.value,
                  riType: item.secondaryValue,
                  riCo: item.thirdValue,
                  acctNoSfx: item.fourthValue,
                  rcvyDocNo: item.label
                }
                if (this.checkedItems.includes(item.value)) {
                  const rcvyItem = {
                    key: item.label,
                    clmNo: item.value,
                    riType: item.secondaryValue,
                    riCo: item.thirdValue,
                    acctNoSfx: item.fourthValue,
                    rcvyDocNo: item.label
                  }
                  this.selectedItems.push(rcvyItem)
                }
                this.items.push(convertList)
                this.displayItems.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doSelect(opt, caller) {
      let selectedObj = opt
      this.$emit('doAssign', selectedObj)
      this.$emit('close', caller)
    },
    doClearClmFilters() {
      this.filtersClm.claimNo = ''
      this.filtersClm.accountNo = this.accountNo
      this.doInit()
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
